import React, {useState, useEffect, useRef } from "react";
import { Box, Button } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebMultipleSelectStore({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const imageRef = useRef(null);
    const [imageWidth, setImageWidth] = useState(0);
    const [selectedOptions, setSelectedOptions] = useState([]);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setImageWidth(0);
        setSelectedOptions([]);
    }, [question]);

    useEffect(() => {
        if (imageRef.current) {
            setImageWidth(imageRef.current.offsetWidth);
        }
    }, [imageRef]);

    const buttonWidth = Math.min(imageWidth / 3, 200);

    const handleSelect = (option) => {
        let updatedOptions;
        if (selectedOptions.includes(option)) {
            updatedOptions = selectedOptions.filter((item) => item !== option);
        } else {
            updatedOptions = [...selectedOptions, option];
        }
        setSelectedOptions(updatedOptions);

        // we will enabled the next button if can proceed
        const canProceed = updatedOptions.length >= data.chooseLength;
        onAnswer({
            canProceed,
            answer: updatedOptions,
        });
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "white",
                padding: "20px",
            }}
        >
            <Box component="img"
                ref={imageRef}
                src={`${imagesResources}${data.image}`}
                alt="Question Visual"
                sx={{
                    maxWidth: "100%",
                    height: "auto",
                }}
                onLoad={() => {
                    if (imageRef.current) {
                        setImageWidth(imageRef.current.offsetWidth);
                    }
                }}
            />

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    marginTop: "20px",
                    width: `${imageWidth}px`,
                    maxWidth: "100%",
                }}
            >
                {questionData.questionList.map((option, index) => (
                    <Button
                        key={index}
                        variant="contained"
                        onClick={() => handleSelect(option)}
                        sx={{
                            fontSize: "18px",
                            width: `${buttonWidth}px`,
                            fontWeight: "bold",
                            cursor: "pointer",
                            userSelect: "none",
                            color: "black",
                            backgroundColor: selectedOptions.includes(option)
                                ? "rgb(175, 226, 62)"
                                : "rgb(218, 218, 218)",
                            borderBottom: `10px solid ${
                                selectedOptions.includes(option)
                                    ? "rgb(99, 151, 41)"
                                    : "rgb(128, 128, 128)"
                            }`,
                            "&.MuiButton-contained": {
                                backgroundColor: selectedOptions.includes(
                                    option
                                )
                                    ? "rgb(175, 226, 62)"
                                    : "rgb(218, 218, 218)",
                                boxShadow: "none",
                            },
                            "&:hover.MuiButton-contained": {
                                backgroundColor: selectedOptions.includes(
                                    option
                                )
                                    ? "rgb(175, 226, 62)"
                                    : "rgb(218, 218, 218)",
                                boxShadow: "none",
                            },
                        }}
                    >
                        {selectedOptions.includes(option)
                            ? "Selected"
                            : "Select this shop"}
                    </Button>
                ))}
            </Box>
        </Box>
    );
};